<template>
  <div id="em-construcao">
    <div id="illustration">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/exceptionjr-site.appspot.com/o/under-construction.svg?alt=media&token=67cd2732-0616-4879-b999-c37a778e1f12"
        alt="under construction"
      />
    </div>
    <h1>Página em construção</h1>
    <div id="info">
      <p>
        Desculpe-nos!
        Ainda faltam cerca de
        <strong>12 xícaras de café</strong> para ela ficar pronta
      </p>
      <p>Enquanto a gente está trabalhando para terminar, navegue pelas outras páginas do nosso site!</p>
      <div id="links">
        <router-link
          v-for="menuLink in menuLinks"
          :key="menuLink.title"
          :to="menuLink.to"
        >{{menuLink.title}}</router-link>
      </div>
    </div>
    <!-- <ExceptionBtn class="btn-home" to="/">voltar</ExceptionBtn> -->
  </div>
</template>

<script>
// import ExceptionBtn from "@/components/ExceptionBtn";
export default {
  components: {
    // ExceptionBtn
  },
  data() {
    return {};
    computed: {
    }
  },
  methods: {},
  computed: {
    menuLinks() {
      return this.$store.state.menuLinks.filter(link => {
        if (link.title != "projetos") {
          return link;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
#em-construcao {
  width: 100%;
  display: grid;
  grid-gap: 15px;

  @include for-tablet-portraid-up {
    box-sizing: border-box;
    padding: 0 30px;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr 3fr;
  }

  #illustration {
    img {
      width: 100%;
    }
    @include for-tablet-portraid-up {
      grid-row: 1 / -1;
    }
  }
  h1 {
    // font-size: 2.5rem;
    font-size: 2.5rem;
    font-weight: 700;
    align-self: center;
    text-align: center;
    color: $verde-exception;
    grid-row: 1;

    @include for-tablet-portraid-up {
      // grid-row: 1;
      font-size: 3rem;
    }
  }
  #info {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    // align-items: center;
    @include for-tablet-portraid-up {
      grid-column: 2;
    }
    p {
      margin: 0;
      margin-bottom: 20px;
      font-family: $fonte-secundaria;
      font-size: 1.2rem;
    }
  }

  #links {
    display: flex;
    flex-direction: column;

    a {
      font-weight: 500;
      font-size: 1.5rem;
      background: $verde-exception;
      padding: 10px 20px;
      border-radius: 8px;
      margin-bottom: 10px;

      color: #fff;
      text-decoration: none;

      transition: all 0.2s;
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}
</style>
